<template>
  <transition name="fade">
    <div v-if="visible" class="Loader">
      <img src="/img/loader.svg" alt="loading" />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    visible: Boolean,
    theme: String,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.Loader {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(255,255,255,0.6);
}
</style>
